import { render } from "./ExpiredIndicatorDot.vue?vue&type=template&id=e47122e4&scoped=true"
import script from "./ExpiredIndicatorDot.vue?vue&type=script&lang=js"
export * from "./ExpiredIndicatorDot.vue?vue&type=script&lang=js"

import "./ExpiredIndicatorDot.vue?vue&type=style&index=0&id=e47122e4&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47122e4"]])

export default __exports__